import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.css'],
  imports: [NgClass, FormsModule, TranslocoPipe],
})
export class SearchBarComponent implements OnInit {
  searchTerm = '';
  @Input() filteredExperiments!: any[];
  @Output() searchUpdated = new EventEmitter<string>();
  showFilteredExperiments = false; //Variable to control the display of filtered experiments.
  isSearchBarSelected = false;
  showSuggestions = false;

  numberOfCharactersToShowSuggestions = 3;

  constructor() {}

  ngOnInit(): void {}

  searchExperiments() {
    this.searchTerm = this.searchTerm.trimStart();
    this.searchUpdated.emit(this.searchTerm);
    this.showFilteredExperiments =
      this.searchTerm.length >= this.numberOfCharactersToShowSuggestions &&
      this.filteredExperiments.length > 0;
    this.showSuggestions =
      this.searchTerm.length >= this.numberOfCharactersToShowSuggestions;
  }

  selectSuggestion(suggestion: string) {
    this.searchTerm = suggestion;
    this.searchUpdated.emit(this.searchTerm);
  }
}
